import React, {useEffect, useState, ChangeEvent, KeyboardEvent, Component} from 'react';
import ReactDOM from 'react-dom';
import ApexCharts from 'apexcharts'


/*function graphFunction() {
    new ApexCharts(document.querySelector("#reportsChart"), {
        series: [{
          name: "판매수량",
          data: [31, 40, 28, 51, 42, 82, 56],
        }, {
          name: "판매금액",
          data: [11, 32, 45, 32, 34, 52, 41]
        }, {
          name: "주문고객",
          data: [15, 11, 32, 18, 9, 24, 11]
        }],
        chart: {
          height: 300,
          type: "area",
          toolbar: {
            show: false
          },
        },
        markers: {
          size: 4
        },
        colors: ["#4154f1", "#2eca6a", "#ff771d"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.3,
            opacityTo: 0.4,
            stops: [0, 90, 100]
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        xaxis: {
          type: "date",
          categories: ["09-19", "09-20", "09-21", "09-22", "09-23", "09-24", "09-25"]
        },
        tooltip: {
          x: {
            format: 'MM/yy'
          },
        }
      }).render();
}

function Graph(){
    return (
        <script>
        document.addEventListener("DOMContentLoaded", graphFunction);
        </script>
    );
}*/



const StatisticsDailySales = () => {

    const thisYear = new Date().getYear() + 1900;
    const thisMonth = new Date().getMonth() + 1;
    const thisDate = new Date().getDate();

    const today = thisYear + "-" + thisMonth + "-" + thisDate;

    console.log(today);

    const selectDate = (e) => {
        console.log(e.target.value);
    }


    return (
<div className="row">



    <div className="card">
    <div className="card-body">
        <h5 className="card-title">daily sales list</h5>

        <div className="row mb-3">
        <div className="col-sm-2">
            <input type="date" className="form-control" defaultValue="2024-10-12" />
        </div>
        <div className="col-sm-1">
            ~
        </div>
        <div className="col-sm-2">
            <input type="date" className="form-control" defaultValue="2024-10-14" />
        </div>                
        <div className="col-sm-3">
            <button type="button" className="btn btn-primary">Search</button>
        </div>
        <div className="col-sm-4">
            &nbsp;
        </div>
        </div>

        <div id="reportsChart">그래프영역</div>


        {/*<script>
          document.addEventListener("DOMContentLoaded", () => {
            new ApexCharts(document.querySelector("#reportsChart"), {
              series: [{
                name: '판매수량',
                data: [31, 40, 28, 51, 42, 82, 56],
              }, {
                name: '판매금액',
                data: [11, 32, 45, 32, 34, 52, 41]
              }, {
                name: '주문고객',
                data: [15, 11, 32, 18, 9, 24, 11]
              }],
              chart: {
                height: 300,
                type: 'area',
                toolbar: {
                  show: false
                },
              },
              markers: {
                size: 4
              },
              colors: ['#4154f1', '#2eca6a', '#ff771d'],
              fill: {
                type: "gradient",
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.3,
                  opacityTo: 0.4,
                  stops: [0, 90, 100]
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'smooth',
                width: 2
              },
              xaxis: {
                type: 'date',
                categories: ["09-19", "09-20", "09-21", "09-22", "09-23", "09-24", "09-25"]
              },
              tooltip: {
                x: {
                  format: 'MM/yy'
                },
              }
            }).render();
          });
        </script>*/}






        <table className="table">
        <thead>
            <tr>
            <th scope="col" rowSpan="2">date</th>
            <th scope="col" colSpan="1">매출</th>
            <th scope="col" colSpan="4">세부내역</th>
            <th scope="col" rowSpan="2">매입가</th>
            <th scope="col" rowSpan="2">이익금</th>
            <th scope="col" rowSpan="2">판매건수</th>
            <th scope="col" rowSpan="2">판매건 평균</th>
            </tr>
            <tr>
            <th scope="col">순매출|소비세</th>
            <th scope="col">매출</th>
            <th scope="col">할인</th>
            <th scope="col">포인트</th>
            <th scope="col">쿠폰</th>
            </tr>
        </thead>
        <tbody>


            <tr>
            <td>2024-10-12(<font color="blue">土</font>)</td>
            <td>
                1,100,000<br />
                (<span style={{fontSize: "12px"}}>1,000,000</span> | <span style={{fontSize: "12px"}}>100,000</span>)
            </td>
            <td>1,200,000</td>
            <td>100,000</td>
            <td>0</td>
            <td>0</td>
            <td>600,000</td>
            <td>400,000</td>
            <td>200</td>
            <td>5,000</td>               
            </tr>

            <tr>
            <td>2024-10-13(<font color="red">日</font>)</td>
            <td>
                1,100,000<br />
                (<span style={{fontSize: "12px"}}>1,000,000</span> | <span style={{fontSize: "12px"}}>100,000</span>)
            </td>
            <td>1,200,000</td>
            <td>100,000</td>
            <td>0</td>
            <td>0</td>
            <td>600,000</td>
            <td>400,000</td>
            <td>200</td>
            <td>5,000</td>               
            </tr>

            <tr>
            <td>2024-10-14(月)</td>
            <td>
                1,100,000<br />
                (<span style={{fontSize: "12px"}}>1,000,000</span> | <span style={{fontSize: "12px"}}>100,000</span>)
            </td>
            <td>1,200,000</td>
            <td>100,000</td>
            <td>0</td>
            <td>0</td>
            <td>600,000</td>
            <td>400,000</td>
            <td>200</td>
            <td>5,000</td>               
            </tr>


        </tbody>
        </table>


    </div>
    </div>


</div>



    );

}

export default StatisticsDailySales;